import {
  AuthFailedReason,
  HostedWebContentAuthSdkService,
  IWindowAuthenticationService,
} from '../hosted-web-content-auth-sdk';
import { SdkMessageTypes } from '../constants';
import { ITelemetryService } from '../interfaces';
import { BaseAuthenticationMessageHandler } from './base-auth-message-handler';

/**
 * Responsible for handling authentication related message requests.
 */
export class AuthenticationWindowMessageHandler extends BaseAuthenticationMessageHandler {
  constructor(
    protected appAuthSdkHost: HostedWebContentAuthSdkService,
    protected authenticationService?: IWindowAuthenticationService,
    protected telemetryService?: ITelemetryService
  ) {
    super(appAuthSdkHost, authenticationService, telemetryService);
  }
  public initHandlers(): void {
    super.initHandlers();
    this.registerHandler(SdkMessageTypes.authentication.notifySuccess, this.handleNotifySuccess);
    this.registerHandler(SdkMessageTypes.authentication.notifyFailure, this.handleNotifyFailure);
  }

  protected async handleNotifySuccess(_event: MessageEvent, data: string): Promise<void> {
    this.appAuthSdkHost.closeWindow();
    this.appAuthSdkHost.stopAuthWindowMonitor();
    return this.authenticationService!.notifySuccess!(data);
  }

  protected async handleNotifyFailure(_event: MessageEvent, reason: string): Promise<void | (string | boolean)[]> {
    this.appAuthSdkHost.closeWindow();
    this.appAuthSdkHost.stopAuthWindowMonitor();
    return this.authenticationService!.notifyFailure!(reason, AuthFailedReason.Other);
  }
}
